import React from 'react';

export class Footer extends React.Component {
  render() {
    return (
      <div className="container is-fullhd custom-footer-wrapper">
        <div className="custom-footer">
          <p>29 E. Madison St., Suite 500, Chicago, IL 60602 • 312.701.1100</p>
          <p>
            Securities offered through Cambridge Investment Research, Inc., a
            Broker/Dealer, Member FINRA / SIPC. Investment Advisory Services
            offered through Retirement Plan Advisors, LLC, a Federally
            Registered Investment Adviser. Cambridge is a partial owner of
            Retirement Plan Advisors, LLC. Registered representatives may only
            conduct business with residents of the states for which they are
            properly registered.
          </p>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Footer.jsx